import React, { useState, useEffect } from "react";
import Navbar from "../../components/template/Navbar";
import Template from "../../components/template/Template";
import { Button, Input } from "antd";
import { IoRefreshOutline } from "react-icons/io5";
import Select from "react-select";
import { IoCalendarOutline } from "react-icons/io5";
import { IoIosCopy } from "react-icons/io";
import { GiSpeaker } from "react-icons/gi";
import DatePicker from "react-datepicker";
import { DropdownButton, Dropdown } from "react-bootstrap";
import {
  AxiosCustomGet,
  AxiosCustomPost,
} from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import Cookies from "js-cookie";
import moment from "moment";

function DailyTask(props) {
  const now = Date.now();
  const [date, setDate] = useState(Date.now());
  const [preOpenAdded, setPreOpenAdded] = useState(false);
  const [preCloseAdded, setPreCloseAdded] = useState(false);
  const [outlet, setOutlet] = useState([]);
  const [outletId, setOutletId] = useState(1);
  const [tasks, setTasks] = useState([]);
  const [taskOpen, setTaskOpen] = useState();
  const [taskClose, setTaskClose] = useState();
  const [notes, setNotes] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [lastPage, setLastPage] = useState(0);
  const [totalRecord, setTotalRecord] = useState(0);

  useEffect(() => {
    getOutlet();
    getTasks();
  }, []);

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setOutlet({
          outlet_list: response.data.data.map((item) => ({
            value: item.id,
            label: item.name,
          })),
        });
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getTasks = (outlet, date) => {
    let startDate = moment(date).format("YYYY-MM-DD");
    // let endDate = `${date?.getFullYear()}-${date?.getMonth()}-${date?.getDate() + 1}`;
    // console.log(startDate);
    // console.log(endDate);
    let url = `${process.env.REACT_APP_BASE_API_URL}task?outlet_id=${outlet}&date_start=${startDate}&date_end=${startDate}`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setTasks(response.data.data.items);
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const addTask = (type) => {
    if (taskOpen !== undefined || taskClose !== undefined) {
      const data = {
        outlet_id: outletId,
        name_task: type === "pre-open" ? taskOpen : taskClose,
        notes: notes,
        type: type,
        date: moment(date).toDate(),
      };
      console.log(data);
      let url = `${process.env.REACT_APP_BASE_API_URL}task`;
      AxiosCustomPost(
        url,
        data,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        (response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          type === "pre-open" && setPreOpenAdded(false);
          type === "pre-close" && setPreCloseAdded(false);
          getTasks(outletId, date);
        },
        (error) => {
          console.log(error);
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: error.response.data,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        }
      );
    } else {
      SwalToast.fire({
        icon: "error",
        title: "Tugas Belum diisi",
      });
    }
  };
  
  return (
    <div>
      <div style={{ padding: 24 }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#303030" }}>
            Tugas Harian
          </div>
          <Button
            style={{
              border: "1px solid #DCDCDC",
              borderRadius: 5,
              height: 36,
              width: 120,
            }}
          >
            <div style={{ color: "#2C465C" }}>
              <IoRefreshOutline style={{ margin: 5 }} />
              Refresh
            </div>
          </Button>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ display: "flex", marginTop: 40 }}>
            <div style={{ width: 180 }}>
              <div>Cabang:</div>
              <Select
                options={outlet?.outlet_list}
                onChange={(e) => {
                  // console.log(outlet.outlet_list[0].label)
                  setOutletId(e.value);
                  getTasks(e.value, date);
                }}
              />
            </div>
            <div className="ml-2">
              <div>Tanggal:</div>
              <div className="d-flex align-items-center">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={date}
                  onChange={(date) => {
                    setDate(date);
                    getTasks(outletId, date);
                    console.log("change", moment(date).format("YYYY-MM-DD"));
                  }}
                  className="form-control"
                />
                <IoCalendarOutline
                  style={{ fontSize: 20, marginLeft: -30, zIndex: 1 }}
                />
              </div>
            </div>
          </div>
          <Button
            disabled={
              moment(date).format("YYYY-MM-DD") !==
              moment(now).format("YYYY-MM-DD")
            }
            style={{
              alignSelf: "flex-end",
              border: "1px solid #DCDCDC",
              borderRadius: 5,
              height: 36,
              width: 120,
              background:
                moment(date).format("YYYY-MM-DD") ==
                moment(now).format("YYYY-MM-DD")
                  ? "#F23434"
                  : "#D6D6D6",
            }}
          >
            <div style={{ color: "#fff" }}>
              <GiSpeaker style={{ fontSize: 20 }} />
              Ingatkan
            </div>
          </Button>
        </div>

        <div style={{ display: "flex", marginTop: 24 }}>
          <div
            style={{
              marginRight: 10,
              flex: 1,
              padding: 12,
              boxShadow: "0px 4px 12px rgba(54, 53, 53, 0.12)",
              borderRadius: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 24,
              }}
            >
              <div style={styles.title}>Tugas Pre-Open</div>
              <DropdownButton
                variant="light"
                align="end"
                title={
                  <>
                    <IoIosCopy /> Salin
                  </>
                }
                style={{
                  height: 250,
                  width: 150,
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                {outlet?.outlet_list?.map((item) => {
                  return (
                    <Dropdown.Item eventKey={item.id}>
                      {item.label}
                    </Dropdown.Item>
                  );
                })}
              </DropdownButton>
            </div>
            <div style={{ marginTop: -250 }}>
              {tasks.map((item) => {
                if (item.type == "pre-open") {
                  return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        value={"checked"}
                        className="col-1  d-flex  justify-content-center"
                        style={styles.checkbox}
                        type="checkbox"
                      />
                      {item.name_task}
                    </div>
                  );
                }
              })}
            </div>
            {!preOpenAdded ? (
              <div
                style={{ margin: 10, cursor: "pointer" }}
                onClick={() => setPreOpenAdded(true)}
              >
                <span style={{ fontSize: 20 }}>+</span> Tambah Tugas
              </div>
            ) : (
              <div
                style={{
                  margin: 10,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Input
                  style={{
                    width: "90%",
                    borderRadius: 50,
                    padding: "7px 12px",
                  }}
                  onChange={(e) => setTaskOpen(e.target.value)}
                  placeholder="Ketikkan Tugas"
                />
                <div
                  style={{
                    fontSize: 24,
                    marginLeft: 10,
                    cursor: "pointer",
                    zIndex: 1,
                  }}
                  onClick={() => addTask("pre-open")}
                >
                  +
                </div>
              </div>
            )}
            <div style={{ marginTop: 24 }}>
              <div style={{ color: "#A6A6A6" }}>Officer/Pod Bertugas:</div>
              <div
                style={{ display: "flex", alignItems: "center", padding: 5 }}
              >
                <div
                  style={{
                    background: "#A6A6A6",
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                  }}
                >
                  <img src="" />
                </div>
                <div style={{ marginLeft: 10 }}>Nama Officer</div>
              </div>
            </div>
          </div>

          <div
            style={{
              marginRight: 10,
              flex: 1,
              padding: 12,
              boxShadow: "0px 4px 12px rgba(54, 53, 53, 0.12)",
              borderRadius: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                cursor: "pointer",
                marginBottom: 24,
              }}
            >
              <div style={styles.title}>Tugas Pre-Close</div>
              <DropdownButton
                variant="light"
                align="end"
                title={
                  <>
                    <IoIosCopy /> Salin
                  </>
                }
                style={{
                  height: 250,
                  width: 150,
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                {outlet?.outlet_list?.map((item) => {
                  return (
                    <Dropdown.Item eventKey={item.id}>
                      {item.label}
                    </Dropdown.Item>
                  );
                })}
              </DropdownButton>
            </div>
            <div style={{ marginTop: -250 }}>
              {tasks.map((item) => {
                if (item.type == "pre-close") {
                  return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        value={"checked"}
                        className="col-1  d-flex  justify-content-center"
                        style={styles.checkbox}
                        type="checkbox"
                      />
                      {item.name_task}
                    </div>
                  );
                }
              })}
            </div>
            {!preCloseAdded ? (
              <div
                style={{ margin: 10, cursor: "pointer" }}
                onClick={() => setPreCloseAdded(true)}
              >
                <span style={{ fontSize: 20 }}>+</span> Tambah Tugas
              </div>
            ) : (
              <div
                style={{
                  margin: 10,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Input
                  style={{
                    width: "90%",
                    borderRadius: 50,
                    padding: "7px 12px",
                  }}
                  onChange={(e) => setTaskClose(e.target.value)}
                  placeholder="Ketikkan Tugas"
                />
                <div
                  style={{
                    fontSize: 24,
                    marginLeft: 10,
                    cursor: "pointer",
                    zIndex: 1,
                  }}
                  onClick={() => addTask("pre-close")}
                >
                  +
                </div>
              </div>
            )}
            <div style={{ marginTop: 24 }}>
              <div style={{ color: "#A6A6A6" }}>Officer/Pod Bertugas:</div>
              <div
                style={{ display: "flex", alignItems: "center", padding: 5 }}
              >
                <div
                  style={{
                    background: "#A6A6A6",
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                  }}
                >
                  <img src="" />
                </div>
                <div style={{ marginLeft: 10 }}>Nama Officer</div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: 24 }}>
          <div style={styles.title}>Tugas Harian Minggu Ini</div>
        </div>
      </div>
    </div>
  );
}

export default DailyTask;

const styles = {
  textLabel: { color: "#A6A6A6", margin: "15px 0" },
  textValue: { margin: "15px 0" },
  title: { fontSize: 14, fontWeight: 700, color: "#303030" },
  checkbox: {
    accentColor: "#fa6629",
    width: 15,
    height: 15,
    margin: "9px 0",
  },
};
